import { render } from "./EventCalendar.vue?vue&type=template&id=2c53f3ec&scoped=true"
import script from "./EventCalendar.vue?vue&type=script&lang=js"
export * from "./EventCalendar.vue?vue&type=script&lang=js"

import "./EventCalendar.vue?vue&type=style&index=0&id=2c53f3ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c53f3ec"]])

export default __exports__